import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

const PrivateRouteWrapper = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(routeProps) => (
        <PrivateRoute {...routeProps} component={Component} key={routeProps.location.pathname} />
      )}
    />
  );
};

export default PrivateRouteWrapper;
